import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("mwcrm_token");
    if (!token) {
      setUser(false);
      setChecked(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("mwcrm_token");
        setUser(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mwcrm_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mwcrm_token");
    setUser(false);
  };

  const isAdmin = user && user.role === "admin";
  const hasPerm = (p) =>
    !!user && (user.role === "admin" || user?.permissions?.[p]);

  return (
    <AuthContext.Provider value={{ user, checked, login, logout, isAdmin, hasPerm }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
